export default "__VITE_ASSET__bP3hwWp0__"